import {logoutSuccess} from "./actions";
import {clearToken} from "../../services/auth";

export function logout() {
    return function (dispatch) {
        clearToken();

        dispatch(logoutSuccess());
    }
}